import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const methods = [{
  title: 'La trampa de la moderación',
  description: 'Intentar "usar menos el móvil" no funciona si el entorno sigue siendo el mismo.'
}, {
  title: 'Apps de bloqueo de tiempo',
  description: 'Son parches que no resuelven el daño biológico de fondo.'
}, {
  title: 'Motivación de video de YouTube',
  description: 'La motivación es un sentimiento barato; dura 10 minutos y desaparece cuando el aburrimiento golpea.'
}, {
  title: 'La fuerza de voluntad bruta',
  description: 'Es una batería finita que se agota frente a un entorno diseñado para tentarte.'
}];
export function FailedMethods() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark px-4 py-16 md:py-24" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-27">
          <h2 className="font-bebas text-4xl md:text-6xl text-white leading-tight" data-id="element-28">
            POR QUÉ LO QUE INTENTASTE NO FUNCIONÓ
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
            {methods.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-lighter border border-amber/20 rounded-lg p-6 space-y-3" data-id="element-30">
                <div className="flex items-start gap-3" data-id="element-31">
                  <XCircleIcon className="w-6 h-6 text-amber flex-shrink-0 mt-1" data-id="element-32" />
                  <div className="space-y-2" data-id="element-33">
                    <h3 className="font-inter font-bold text-lg text-white" data-id="element-34">
                      {method.title}
                    </h3>
                    <p className="font-inter text-sm text-text/70 leading-relaxed" data-id="element-35">
                      {method.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}